<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">
                {{ meta.title }}
                <div v-if="isRequiered" class="dx-field-item-required-mark">&nbsp;*</div>
            </div>
            <div :class="fieldValueClass">
                <ai-select-box-clearable
                    v-model:value="value"
                    :data-source="dataSource"
                    :disabled="disabled"
                    :display-expr="meta.extParams.displayExpr"
                    :read-only="readOnly"
                    :showClearButton="meta.showClearButton || false"
                    :value-expr="meta.extParams.valueExpr"
                    @opened="onOpenHandler"
                    @valueChanged="valueChanged"
                />
                <div
                    v-if="error"
                    class="ai-dx-invalid"
                    @click="() => callbacks.notifyErrorMessage(error.message)"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, onBeforeMount, ref } from 'vue';
import AiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';
import { getDictionary } from '@/service/card-service';

const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            getDictionary: null,
        }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
});

const serverData = inject('serverData');
const userData = inject('userData');
const dataSource = ref(props.meta.ds);
const validationResult = inject('validationResult');

const isRequiered = computed(() => {
    return props.meta.validationRules?.required;
});

const onOpenHandler = async () => {
    await getDictionaryHandler();
};

onBeforeMount(async () => {
    if (props.meta.extParams) {
        const initialDS = [
            {
                [`${props.meta.extParams.valueExpr}`]: userData?.value[props.meta.fieldNameText],
                [`${props.meta.extParams.displayExpr}`]: userData?.value[props.meta.fieldNameId],
            },
        ];
        if (initialDS) {
            dataSource.value = initialDS;
        }
    }
});

const getDictionaryHandler = async () => {
    if (props.callbacks.getDictionary) {
        await props.callbacks.getDictionary();
    } else {
        if (props.meta.ds) {
            dataSource.value = props.meta.ds;
        } else {
            dataSource.value = await getDictionary(props.meta.extParams.dictionaryRoutePath);
        }
    }
};

const valueChanged = e => {
    userDataChange(e.value, e.text);
};

const userDataChange = (value, text) => {
    validationResult.value = validationResult.value.filter(s => {
        return s.fieldNameText !== props.meta.fieldNameText;
    });
    userData.value[props.meta.fieldNameText] = value;
    if (text) {
        userData.value[props.meta.fieldNameId] = text;
    }
    props.callbacks.userDataChanged();
};
const error = computed(() => {
    return validationResult.value.find(s => s.fieldNameText === props.meta.fieldNameText);
});
const isModified = computed(() => {
    return userData?.value[props.meta.fieldNameText] !== serverData?.value[props.meta.fieldNameText];
});

const value = computed(() => {
    if (userData.value[props.meta.fieldNameText] === undefined) {
        return null;
    }
    return userData.value[props.meta.fieldNameText];
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': isModified.value,
    };
});
</script>
